import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';

import InfiniteScroll from 'react-infinite-scroller';
import {Item, Loader} from 'semantic-ui-react';

import {linksList} from '../actions';

import RedditItem from './Item';

const pageStart = 0;

class RedditList extends Component {
    constructor(props) {
        super(props);
        const {
            match: {
                params: {
                    subreddit
                }
            }
        } = props;
        this.state = {
            page: pageStart,
            path: subreddit
                ? `/r/${subreddit}`
                : ''
        };
    }

    loadMore = (page) => {
        const {after} = this.props, {path} = this.state;
        this
            .props
            .linksList(path, {after});
        this.setState({page});
    }

    shouldComponentUpdate({loading}) {
        return loading !== this.props.loading;
    }

    render() {
        const {after, items} = this.props, {page} = this.state,
            hasMore = page === pageStart || Boolean(after),
            loader = <Item key="RedditList-loader">
                <Loader active={true} inline="centered"/>
            </Item>;
        return <Item.Group
            as={InfiniteScroll}
            className="RedditList"
            divided={true}
            hasMore={hasMore}
            initialLoad={true}
            loader={loader}
            loadMore={this.loadMore}
            pageStart={pageStart}
            relaxed="very"
            threshold={640}>
            {items.map(item => <RedditItem key={item.id} data={item}/>)}
        </Item.Group>
    }
}

const connectedList = connect(({clientReddit: {
        links
    }}) => links, {linksList})(RedditList);
export default withRouter(connectedList);


// WEBPACK FOOTER //
// ./src/apps/client-reddit/components/List.js